



















































































import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import store from 'src/assets/store'
import MessengerDialog from 'src/components/messenger/Messenger.vue'
import PersonAvatar from 'src/components/account/PersonAvatar.vue'
import { AttendeeItem, ItemType } from 'src/graphql/types'

@Component({
  components: {
    MessengerDialog,
    PersonAvatar
  }
})
export default class AttendeeItemMenu extends Vue {
  ItemType = ItemType
  me = store.state.person

  @Prop()
  readonly item!: AttendeeItem

  @Ref()
  readonly messenger!: MessengerDialog

  get light () {
    return this.$q.screen.lt.md
  }
}
